import React, { useContext, useEffect, useState } from "react";
import { Dialog } from "@headlessui/react";
import { DataContext } from "../../../helper/HelperOne";
import axios from "axios";
import HeaderWithButton from "../../Utility/HeaderWithButton";
import TopStats from "../../Utility/TopStats";
import HeaderWithAction from "../../Utility/HeaderWithAction";
import LeadBranchList from "./LeadBranchList";
import { toast } from "react-toastify";
import { EllipsisVerticalIcon } from "lucide-react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { PencilSquareIcon } from "@heroicons/react/20/solid";

function LeadBranchCreate() {
  const user = JSON.parse(localStorage.getItem("user"));
  const branchPermission = user?.settings_role_based_access?.some(
    (access) => access.label_id == 2 && access.label_value != 0
  );

  const { searchData } = useContext(DataContext);
  const [openDialogBoxForBranch, setOpenDialogBoxForBranch] = useState(false);
  const [branchDataList, setBranchDataList] = useState([]);
  const [paginationBranchDatas, setPaginationBranchDatas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editIdCryptForBranch, setEditIdCryptForBranch] = useState(null);

  
  const [branchInputs, setBranchInputs] = useState({
    branch_name: "",
    branch_address_1: "",
    branch_address_2: "",
    branch_city: "",
    branch_pincode: "",
    branch_state: "",
    branch_phone: "",
    branch_email: "",
    branch_website: "",
    branch_status: "",
    
  });

  const [branchLogo,setBranchLogo] = useState("")

  const [requiredFields, setRequiredFields] = useState({
    branch_name: "",
    branch_address_1: "",
    branch_address_2: "",
    branch_city: "",
    branch_pincode: "",
    branch_state: "",
    branch_phone: "",
    branch_email: "",
    branch_website: "",
    branch_status: "",
    
    });

  const [isEditing, setIsEditing] = useState(false);
    const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [saveBtn, setSaveBtn] = useState("save");
  const [currentPage, setCurrentPage] = useState(1);

  const fetchBranchesData = async (page = 1) => {
    const token = localStorage.getItem("token");

    try {
      const apiUrl = searchData
        ? `public/api/admin/branch/pagination?page=${page}&search=${searchData}`
        : `public/api/admin/branch/pagination?page=${page}`;

      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

     

      setBranchDataList(response.data.branch.data);
      setPaginationBranchDatas(response.data.branch);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchBranchesData();
  }, [searchData]);

  const handleAddBranch = async() => {
    setLoading(true);
    setOpenDialogBoxForBranch(true);
    setSaveBtn("save");
    try {
        // await fetchBranchesData();
        setBranchInputs({
            branch_name: "",
            branch_address_1: "",
            branch_address_2: "",
            branch_city: "",
            branch_pincode: "",
            branch_state: "",
            branch_phone: "",
            branch_email: "",
            branch_website: "",
            branch_status: "",
            branchLogo: "",
          });
    } catch (error) {
        
    } finally{
        setLoading(false);
    }
  };

  const handleDialogClose = async () => {
    setOpenDialogBoxForBranch(false);
  }
  const handleChangeForBranch = (e) => {
    const { name, value } = e.target;

   
        setBranchInputs((prevData) => ({
            ...prevData,
            [name]: value, // Storing text input values
        }));
   
};

const handleChangeForBranchLogo = (e) => {
  const file = e.target.files[0];
  setBranchLogo(file);
};
  

  const handleEditForBranch = async (id_crypt) => {

    setLoading(true);
    setIsEditing(false);
    setOpenDialogBoxForBranch(true);
    setSaveBtn("update");
    toast.success("Now you can edit this branch");
    try {
      const response = await axios.get(
        `public/api/admin/branch/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,

          },
        }
      );

   
      if(response.data.branch){
        await fetchBranchesData();
        setBranchInputs((prev) => ({
          ...prev,
          branch_name: response.data.branch?.branch_name,
          branch_address_1: response.data.branch?.branch_address_1,
          branch_address_2: response.data.branch?.branch_address_2,
          branch_city: response.data.branch?.branch_city,
          branch_pincode: response.data.branch?.branch_pincode,
          branch_state: response.data.branch?.branch_state,
          branch_phone: response.data.branch?.branch_phone,
          branch_email: response.data.branch?.branch_email,
          branch_website: response.data.branch?.branch_website,
          branch_status: response.data.branch?.branch_status,
        }));
        setBranchLogo(response.data.branch?.branchLogo);
      }

    

    } catch (err) {
      toast.error(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };


  const handleSubmitForBranch = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    
    formData.append("branch_name", branchInputs?.branch_name);
    formData.append("branch_address_1", branchInputs?.branch_address_1);
    formData.append("branch_address_2", branchInputs?.branch_address_2);
    formData.append("branch_city", branchInputs?.branch_city);
    formData.append("branch_pincode", branchInputs?.branch_pincode);
    formData.append("branch_state", branchInputs?.branch_state);
    formData.append("branch_phone", branchInputs?.branch_phone);
    formData.append("branch_email", branchInputs?.branch_email);
    formData.append("branch_website", branchInputs?.branch_website);
    formData.append("branch_status", branchInputs?.branch_status);

    // Only append if a file is selected
    if (branchLogo) {
        formData.append("branch_logo", branchLogo);
    }

    
    try {
        const response = await axios.post(
            "public/api/admin/branch/store",
            formData,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );
 
        setOpenDialogBoxForBranch(false);
        await fetchBranchesData();
    } catch (error) {
        setRequiredFields(error.response.data.errors);
    } finally {
        setLoading(false);
    }
};


const handleUpdateForBranch = async (e, id_crypt) => {
  e.preventDefault();

  
  setLoading(true);

  const formData = new FormData();

  formData.append("_method", "PUT"); 
  formData.append("branch_name", branchInputs?.branch_name);
  formData.append("branch_address_1", branchInputs?.branch_address_1);
  formData.append("branch_address_2", branchInputs?.branch_address_2);
  formData.append("branch_city", branchInputs?.branch_city);
  formData.append("branch_pincode", branchInputs?.branch_pincode);
  formData.append("branch_state", branchInputs?.branch_state);
  formData.append("branch_phone", branchInputs?.branch_phone);
  formData.append("branch_email", branchInputs?.branch_email);
  formData.append("branch_website", branchInputs?.branch_website);
  formData.append("branch_status", branchInputs?.branch_status);

  if (branchLogo && branchLogo instanceof File) {
      formData.append("branchLogo", branchLogo);
  } 
  

  try {
      const response = await axios.post(  // Change PUT to POST
          `public/api/admin/branch/update/${id_crypt}`,
          formData,
          {
              headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                  "Content-Type": "multipart/form-data",
              },
          }
      );


      if (response.data) {
          toast.success(response.data.message);
          setOpenDialogBoxForBranch(false);
          await fetchBranchesData();
      }
  } catch (error) {
      console.error("Error updating branch:", error);
      setRequiredFields(error.response?.data?.errors);
  } finally {
      setLoading(false);
  }
};



  return (
    <>

{loading ? (
        <div className="h-screen bg-white">
          <div className="flex justify-center items-center h-full">
            <img
              className="h-16 w-16"
              src="https://icons8.com/preloaders/preloaders/1488/Iphone-spinner-2.gif"
              alt="loader"
            />
          </div>
        </div>
      ) : (
        <>
      <TopStats />

      <HeaderWithButton
        title="Branches"
        description="branchs"
        buttonText="Branch"
        onButtonClick={handleAddBranch}
        showButton={branchPermission}
      />

      <LeadBranchList 
      setEditIdCryptForBranch={setEditIdCryptForBranch}
      setOpenDialogBoxForBranch={setOpenDialogBoxForBranch}
      setIsEditing={setIsEditing}
      setBranchInputs={setBranchInputs}
      setSaveBtn={setSaveBtn}
      fetchBranchesData={fetchBranchesData}
      branchDataList={branchDataList}
      paginationBranchDatas={paginationBranchDatas}
      setCurrentPage={setCurrentPage}
      branchPermission={branchPermission}
      setLoading={setLoading}
      />

      {openDialogBoxForBranch && (
        <Dialog
          open={openDialogBoxForBranch}
          onClose={() => {}}
          className="relative z-10"
        >
          <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className=" flex min-h-full items-end justify-center p-4 text-center sm:items-center  md:min-h-screen sm:p-0">
              <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                {/* <HeaderWithAction
                  title="Branch INFO"
                   handleClose={handleDialogClose}
                   isEditing={isEditing}
                   handleEdit={() => handleEditForBranch(editIdCryptForBranch)}

                /> */}
                <div
                  className="flex justify-between p-4 text-white sticky top-0"
                  style={{ backgroundColor: "#6366f1" }}
                >
                  <h1 className="mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium mb-2 ">
                    Branch
                  </h1>

                  <div className="flex gap-2">
                    
                    {branchPermission && isEditing && (
                      <div className="relative">
                        <button
                          type="button"
                          className="inline-flex items-center gap-x-1 text-sm/6 font-semibold text-gray-900"
                          aria-expanded={isOpenEdit}
                        >
                          <PencilSquareIcon
                            // onClick={() => setIsOpenEdit(!isOpenEdit)} // Toggle visibility
                            onClick={() => {
                              handleEditForBranch(editIdCryptForBranch);
                              setIsOpenEdit(false); // Close after clicking Edit
                            }}
                            className="h-6 w-6 cursor-pointer text-white"
                          />
                        </button>

                        {/* {isOpenEdit && (
                          <div className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4">
                            <div className="w-56 shrink rounded-xl bg-white p-4 text-sm font-semibold text-gray-900 shadow-lg ring-1 ring-gray-900/5">
                              <button
                                type="button"
                                className="block w-full text-left p-2 hover:text-indigo-600"
                                onClick={() => {
                                  handleEditForBranch(editIdCryptForBranch);
                                  setIsOpenEdit(false); // Close after clicking Edit
                                }}
                              >
                                Edit
                              </button>
                            </div>
                          </div>
                        )} */}
                      </div>
                    )}

<XMarkIcon
                      onClick={handleDialogClose}
                      className="h-6 w-6 cursor-pointer"
                    />
                  </div>
                </div>
                <div className="md:grid md:gap-6 p-4">
                  <div className="md:mt-0 md:col-span-2">
                    <form className="grid grid-cols-1  md:grid-cols-1 ">
                      <div className=" overflow-hidden">
                        <div className="p-6">
                          <h2 className="block  text-sm font-medium leading-6 text-gray-900">
                            UNIQUE INFO
                          </h2>

                          <div className="grid grid-cols-6 gap-6 mt-5">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block  text-sm font-medium leading-6 text-gray-900"
                              >
                                 Name
                              </label>

                              <div className="mt-2">
                                <input
                                  name="branch_name"
                                  type="text"
                                  value={branchInputs?.branch_name}
                                  onChange={handleChangeForBranch}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Name"
                                />
                               
                              </div>
                              {requiredFields?.branch_name && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.branch_name}
                                  </p>
                                )}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block  text-sm font-medium leading-6 text-gray-900"
                              >
                                 Email
                              </label>
                              <div className="mt-2">
                                <input
                                  name="branch_email"
                                  type="text"
                                  value={branchInputs?.branch_email}
                                  onChange={handleChangeForBranch}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Email"
                                />
                               
                              </div>
                              {requiredFields?.branch_email && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.branch_email}
                                  </p>
                                )}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block  text-sm font-medium leading-6 text-gray-900">
                               Phone
                              </label>
                              <div className="mt-2">
                                <input
                                  name="branch_phone"
                                  type="text"
                                  value={branchInputs?.branch_phone}
                                  onChange={handleChangeForBranch}
                                  placeholder="Phone"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {requiredFields?.branch_phone && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.branch_phone}
                                  </p>
                                )}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                            <label
                                htmlFor="end_date"
                                className="block  text-sm font-medium leading-6 text-gray-900"
                              >
                                 Website
                              </label>

                              <div className="mt-2">
                                <input
                                  name="branch_website"
                                  type="text"
                                  value={branchInputs?.branch_website}
                                  onChange={handleChangeForBranch}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Website"
                                />
                              </div>
                              {requiredFields?.branch_website && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.branch_website}
                                  </p>
                                )}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block  text-sm font-medium leading-6 text-gray-900"
                              >
                                 Status
                              </label>
                              <div className="mt-2">
                                <input
                                  name="branch_status"
                                  type="text"
                                  value={branchInputs?.branch_status}
                                  onChange={handleChangeForBranch}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="Status"
                                />
                              </div>
                              {requiredFields?.branch_status && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.branch_status}
                                  </p>
                                )}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block  text-sm font-medium leading-6 text-gray-900">
                               State
                              </label>
                              <div className="mt-2">
                                <input
                                  name="branch_state"
                                  type="text"
                                  value={branchInputs?.branch_state}
                                  onChange={handleChangeForBranch}
                                  placeholder="State"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {requiredFields?.branch_state && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.branch_state}
                                  </p>
                                )}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label
                                htmlFor="end_date"
                                className="block  text-sm font-medium leading-6 text-gray-900"
                              >
                                 City
                              </label>
                              <div className="mt-2">
                                <input
                                  name="branch_city"
                                  type="text"
                                  value={branchInputs?.branch_city}
                                  onChange={handleChangeForBranch}
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                  placeholder="City"
                                />
                              </div>
                              {requiredFields?.branch_city && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.branch_city}
                                  </p>
                                )}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block  text-sm font-medium leading-6 text-gray-900">
                               Address 1
                              </label>
                              <div className="mt-2">
                                <input
                                  name="branch_address_1"
                                  type="text"
                                  value={branchInputs?.branch_address_1}
                                  onChange={handleChangeForBranch}
                                  placeholder="Address 1"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {requiredFields?.branch_address_1 && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.branch_address_1}
                                  </p>
                                )}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block  text-sm font-medium leading-6 text-gray-900">
                              Address 2
                              </label>
                              <div className="mt-2">
                                <input
                                  name="branch_address_2"
                                  type="text"
                                  value={branchInputs?.branch_address_2}
                                  onChange={handleChangeForBranch}
                                  placeholder="Address 2"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {requiredFields?.branch_address_2 && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.branch_address_2}
                                  </p>
                                )}
                            </div>

                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <label className="block  text-sm font-medium leading-6 text-gray-900">
                              Pincode
                              </label>
                              <div className="mt-2">
                                <input
                                  name="branch_pincode"
                                  type="text"
                                  value={branchInputs?.branch_pincode}
                                  onChange={handleChangeForBranch}
                                  placeholder="Pincode"
                                  className={`block w-full ${
                                    isEditing && "bg-gray-100"
                                  } rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6`}
                                  disabled={isEditing}
                                />
                              </div>
                              {requiredFields?.branch_pincode && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.branch_pincode}
                                  </p>
                                )}
                            </div>


                            <div className="col-span-full sm:col-span-3 lg:col-span-2">
                              <label className="block  text-sm font-medium text-gray-700">
                                File Upload
                              </label>
                              <div className="mt-2">
                                <label
                                  htmlFor="branchLogo"
                                  className={`flex items-center justify-center w-full px-4 py-2 text-white bg-indigo-600 rounded-md shadow-md cursor-pointer hover:bg-indigo-700 transition-all ${
                                    isEditing
                                      ? "bg-gray-400 cursor-not-allowed"
                                      : ""
                                  }`}
                                >
                                  Upload Image
                                </label>
                                <input
                                  id="branchLogo"
                                  name="branchLogo"
                                  type="file"
                                  accept="image/*"
                                  onChange={handleChangeForBranchLogo}
                                  className="hidden"
                                  disabled={isEditing}
                                />
                                {branchLogo && (
                                  <p className="mt-2 text-sm text-gray-600">
                                    {branchLogo}
                                  </p>
                                )}
                              </div>
                              {requiredFields?.branchLogo && (
                                  <p className="mt-1 text-sm text-red-600">
                                    {requiredFields?.branchLogo}
                                  </p>
                                )}
                            </div>
                          </div>

                          {/* Save Button */}
                          {saveBtn === "save" ? (
                            <div className="bg-white mt-6">
                              <button
                                onClick={handleSubmitForBranch}
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Save
                              </button>
                            </div>
                          ) : (
                            <div className="bg-white mt-6">
                              <button
                                onClick={(e) => handleUpdateForBranch(e,editIdCryptForBranch)}
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Update
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      )}
      </>
      )
    }
    </>
  );
}

export default LeadBranchCreate;
